import React, {Component} from 'react';

class AddCourseModal extends Component {
    state = {
        courseName: '',
        courseSlug: ''
    };

    setNewCourseName = (name) => {

        let slug = name.toString().toLowerCase()
            .replace(/\s+/g, '-') // Replace spaces with -
            .replace(/[^\w\-]+/g, '') // Remove all non-word chars
            .replace(/\-\-+/g, '-') // Replace multiple - with single -
            .replace(/^-+/, '') // Trim - from start of text
            .replace(/-+$/, '');

        this.setState({
            courseName: name,
            courseSlug: slug
        })
    };

    addNewCourse = () => {
        this.props.addNewCourse(this.state.courseName, this.state.courseSlug);
        this.setState({
            courseName: '',
            courseSlug: ''
        });
        this.props.onCloseModal();
    };

    //Renders


    render() {
        return (
            <div
                className="modal fade in"
                id="AddCourseModal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="myModalLabel"
                style={{display: 'block'}}
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span
                                    aria-hidden="true"
                                    onClick={this.props.onCloseModal}
                                >
                                    ×
                                </span>
                            </button>
                            <h4 className="modal-title" id="myModalLabel">Add Course</h4>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="form-group">
                                        <label>Course Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Course Name"
                                            value={this.state.courseName}
                                            onChange={(e) => {this.setNewCourseName(e.target.value)}}
                                        />
                                    </div>
                                    <br />
                                    <div className="form-group">
                                        <label>Course Slug (URI)</label>
                                        <input
                                            className="form-control"
                                            placeholder="Slug"
                                            value={this.state.courseSlug}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-default"
                                data-dismiss="modal"
                                onClick={this.props.onCloseModal}
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                data-dismiss="modal"
                                disabled={this.state.courseName === ''}
                                onClick={this.addNewCourse}
                            >
                                Save changes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}

export default AddCourseModal;


// WEBPACK FOOTER //
// ./src/components/Common/AddCourseModal.js